export class StandByDatas {
	public duration: number = null;
	public endDate: Date = null;
}
